interface CaseStudyItem {
  projectName: string
  client: string
  description?: string
  src: string
  alt: string
  id: string
  tags: [
    ...{
      tag: string
      href: string
    }[],
  ]
  isOneline: boolean
  linkToDetail?: string
}

export const caseStudyItems: CaseStudyItem[] = [
  {
    projectName: 'ファイル転送ミドルウェア HULFT',
    client: '株式会社セゾンテクノロジー',
    src: '/images/img/case/img_thum_hulft.webp',
    alt: 'ファイル転送ミドルウェア HULFT',
    id: 'hulft',
    tags: [
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/hulft',
  },
  {
    projectName: 'マクロミル デザインシステム',
    client: '株式会社マクロミル',
    src: '/images/img/case/img_thum_macromill-designsystem.webp',
    alt: 'マクロミル デザインシステム',
    id: 'macromilldesignsystem',
    tags: [
      {
        tag: 'デザインシステム構築',
        href: '/cases/design-system',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/macromill-designsystem',
  },
  {
    projectName: 'マーケティングデータプラットフォーム Coreka',
    client: '株式会社マクロミル',
    src: '/images/img/case/img_thum_coreka.webp',
    alt: 'マーケティングデータプラットフォーム Coreka',
    id: 'coreka',
    tags: [
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/coreka',
  },
  {
    projectName: 'ぐるっとAI見積り',
    client: 'アート引越センター株式会社',
    src: '/images/img/case/img_thum_guruttoai.webp',
    alt: 'ぐるっとAI見積り',
    id: 'guruttoai',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: '小売/流通/物流', href: '/cases/retail' },
    ],
    isOneline: false,
    linkToDetail: '/cases/gurutto-ai',
  },
  {
    projectName: '地域共生型MaaS meemo',
    client: 'オムロン ソーシアルソリューションズ株式会社',
    src: '/images/img/case/img_thum_meemo.webp',
    alt: '地域共生型MaaS meemo',
    id: 'meemo',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'クラウド導入支援',
        href: '/cases/cloud',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/meemo',
  },
  {
    projectName: '推し活倶楽部',
    client: '株式会社セブンネットショッピング',
    src: '/images/img/case/img_thum_7net.png',
    alt: '推し活倶楽部',
    id: '7net',
    tags: [
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      {
        tag: 'flamingo',
        href: '/cases/flamingo',
      },
      { tag: '小売/流通/物流', href: '/cases/retail' },
    ],
    isOneline: false,
    linkToDetail: '/cases/7net',
  },
  {
    projectName: '共済マイページ',
    client: '日本コープ共済生活共同組合連合会',
    src: '/images/img/case/img_thum_kyosaimypage.png',
    alt: '共済マイページ',
    id: 'kyosaimypage',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'クラウド導入支援',
        href: '/cases/cloud',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: '銀行/保険/証券', href: '/cases/finance' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kyosaimypage',
  },
  {
    projectName: 'グローバルECサイト',
    client: '会宝産業株式会社',
    src: '/images/img/case/img_thum_kaiho.png',
    alt: 'グローバルECサイト',
    id: 'kaiho',
    tags: [
      {
        tag: 'DevOps構築',
        href: '/cases/devops',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      {
        tag: 'プロダクトマネジメント',
        href: '/cases/application-development',
      },
      { tag: '小売/流通/物流', href: '/cases/retail' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kaiho',
  },
  {
    projectName: 're-quest/QJ navi',
    client: '株式会社セイファート',
    src: '/images/img/case/img_thum_seyfert.png',
    alt: 're-quest/QJ navi',
    id: 'seyfert',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/seyfert',
  },
  {
    projectName: 'マンション一斉入居サービス MSS',
    client: 'アート引越センター株式会社',
    src: '/images/img/case/img_thum_mms.png',
    alt: 'マンション一斉入居サービス MSS',
    id: 'mss',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'クラウド導入支援',
        href: '/cases/cloud',
      },
      {
        tag: 'プロダクトマネジメント',
        href: '/cases/product-management',
      },
      { tag: '小売/流通/物流', href: '/cases/retail' },
    ],
    isOneline: false,
    linkToDetail: '/cases/mss',
  },
  {
    projectName: 'アシスタントロボ',
    client: 'データスタジアム株式会社',
    src: '/images/img/case/img_thum_assistantrobo.png',
    alt: 'アシスタントロボ',
    id: 'assistantrobo',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/assistantrobo',
  },
  {
    projectName: 'Tennis-Point アプリ',
    client: 'イオン・シグナ・スポーツ・ユナイテッド株式会社',
    src: '/images/img/case/img_thum_tennispointapp.png',
    alt: 'Tennis-Point アプリ',
    id: 'tennispointapp',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/tennispointapp',
  },
  {
    projectName: '海外頭髪事業DX推進パートナー',
    client: '株式会社カネカ',
    src: '/images/img/case/img_thum_kaneka.png',
    alt: '海外頭髪事業DX推進パートナー',
    id: 'kaneka',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'DX戦略策定',
        href: '/cases/dx',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kaneka',
  },
  {
    projectName: 'キャンプ体験メタバース空間構築',
    client: '名古屋テレビ放送株式会社',
    src: '/images/img/case/img_thum_nagoyatv.png',
    alt: '名古屋テレビ放送株式会社',
    id: 'nagoyatv',
    tags: [
      {
        tag: 'xR/メタバース導入',
        href: '/cases/xr',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/nagoyatv',
  },
  {
    projectName: '災害ボランティア体験VRコンテンツ',
    client: '公益財団法人日本財団ボランティアセンター',
    src: '/images/img/case/img_thum_volnteer.png',
    alt: '災害ボランティア体験VRコンテンツ',
    id: 'volnteer',
    tags: [
      {
        tag: 'xR/メタバース導入',
        href: '/cases/xr',
      },
      { tag: 'その他', href: '/cases/other' },
    ],
    isOneline: false,
    linkToDetail: '/cases/volunteer-ex',
  },
  {
    projectName: 'PEACH JOHN 公式アプリ',
    client: '株式会社ピーチ・ジョン',
    src: '/images/img/case/img_thum_peachjohn.png',
    alt: 'PEACH JOHN 公式アプリ',
    id: 'peachjohn',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: '小売/流通/物流', href: '/cases/retail' },
    ],
    isOneline: false,
    linkToDetail: '/cases/peachjohn',
  },
  {
    projectName: 'ニッセンオンライン',
    client: '株式会社ニッセン',
    src: '/images/img/case/img_thum_nissay.webp',
    alt: 'ニッセンオンライン',
    id: 'nissay',
    tags: [
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      {
        tag: 'flamingo',
        href: '/cases/flamingo',
      },
      { tag: '小売/流通/物流', href: '/cases/retail' },
    ],
    linkToDetail: '/cases/nissen',
    isOneline: false,
  },
  {
    projectName: 'コンタクトレンズが簡単注文できるアプリ',
    client: '株式会社ビジョナリーホールディングス',
    src: '/images/img/case/img_thum_contactlens.webp',
    alt: 'コンタクトレンズが簡単注文できるアプリ',
    id: 'contactlens',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: '小売/流通/物流', href: '/cases/retail' },
    ],
    isOneline: false,
    linkToDetail: '/cases/visionaryholdings',
  },
  {
    projectName: 'QUICK Global Alert',
    client: '株式会社QUICK',
    src: '/images/img/case/img_thum_quickglobalalert.webp',
    alt: 'QUICK Global Alert',
    id: 'quickglobalalert',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/quick',
  },
  {
    projectName: '東京スター銀行アプリ',
    client: '株式会社野村総合研究所',
    src: '/images/img/case/img_thum_tokyostar.webp',
    alt: '東京スター銀行アプリ',
    id: 'tokyostar',
    tags: [
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: '銀行/保険/証券', href: '/cases/finance' },
    ],
    isOneline: false,
    linkToDetail: '/cases/nri',
  },
  {
    projectName: 'docomo Open Inovation Cloud',
    client: '株式会社NTTドコモ',
    src: '/images/img/case/img_thum_docomo.webp',
    alt: 'docomo Open Inovation Cloud',
    id: 'docomo',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'クラウド導入支援',
        href: '/cases/cloud',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/ntt',
  },
  {
    projectName: 'Ultra Caddy',
    client: '株式会社Anchor',
    src: '/images/img/case/img_thum_ultracaddy.webp',
    alt: 'Ultra Caddy',
    id: 'ultracaddy',
    tags: [
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications' },
    ],
    isOneline: false,
    linkToDetail: '/cases/anchor',
  },
  {
    projectName: 'mirron',
    client: '大手化学メーカー',
    src: '/images/img/case/img_thum_mirron.webp',
    alt: 'mirron',
    id: 'mirron',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development',
      },
      {
        tag: 'UI/UXデザイン',
        href: '/cases/uiuxdesign',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing' },
    ],
    isOneline: false,
    linkToDetail: '/cases/mirron',
  },
  {
    projectName: 'JOB理論1dayワークショップ',
    client: '株式会社安藤・間',
    src: '/images/img/case/img_thum_ando.webp',
    alt: 'JOB理論1dayワークショップ',
    id: 'ando',
    tags: [
      {
        tag: '組織開発・人材育成',
        href: '/cases/hip',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing' },
    ],
    isOneline: false,
    linkToDetail: '/cases/ando',
  },
  {
    projectName: 'イノベーション ワークショップ',
    client: 'カヤバ株式会社',
    src: '/images/img/case/img_thum_kayaba.png',
    alt: 'イノベーション ワークショップ',
    id: 'kayaba',
    tags: [
      {
        tag: '組織開発・人材育成',
        href: '/cases/hip',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kayaba',
  },
  {
    projectName: 'DX-DAY アイデアソン',
    client: 'JFE エンジニアリング株式会社',
    src: '/images/img/case/img_thum_dxday.webp',
    alt: 'DX-DAY アイデアソン',
    id: 'dxday',
    tags: [
      {
        tag: '組織開発・人材育成',
        href: '/cases/hip',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing' },
    ],
    isOneline: false,
    linkToDetail: '/cases/jfe',
  },
]
